import React, { Fragment, useState, useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import Tooltip from '@material-ui/core/Tooltip';

const PartialCreditNoteTableActions = ({ data, selectPatients }) => {

    useEffect(() => {
    }, []);

    return (<Fragment>
        <td role="cell">
            {
                data.data.original.seleccionado == true ? <Tooltip title="Quitar de Selección">
                    <IconButton style={{ fontSize: '15px' }} onClick={() => {
                      selectPatients(data.data.original, false);
                    }}>
                        <FontAwesomeIcon icon={faXmark} className="text-danger" />
                    </IconButton>
                </Tooltip> : <Tooltip title="Seleccionar">
                    <IconButton style={{ fontSize: '15px' }} onClick={() => {
                        selectPatients(data.data.original, true);
                    }}>
                        <FontAwesomeIcon icon={faCheck} className="text-success" />
                    </IconButton>
                </Tooltip>
            }
        </td>
    </Fragment>)
}

export default PartialCreditNoteTableActions;